module.exports = __webpack_public_path__ + "img/thumb_InAnotherCastle.d10513a7.jpg";